import { useEffect, useMemo } from 'react'

import { Box, BoxProps } from '@mantine/core'
import { useElementSize } from '@mantine/hooks'
import Cookies from 'js-cookie'

import { SubotCss } from 'components/organisms/subotInlineRevamp/subotCss'
import { SubotInlineRevamp } from 'components/templates/article/dynamicContentComponents'
import ErrorBoundary from 'components/templates/navigatorLayout/errorBoundary'
import { useAppContext } from 'hooks/useAppContext'
import { useIsMobile } from 'hooks/useIsMobile'
import { useRouterExtend } from 'hooks/useRouterExtend'
import { GA_TOKEN_COOKIE } from 'interfaces/constants'
import { SpotlightRiskScreenerSession } from 'interfaces/types'

type RiskScreenerEmbedProps = {
  data: SpotlightRiskScreenerSession
  primaryColor?: string
  isFullContainer?: boolean
  isDisabledAnimationOnMobile?: boolean
  handleOnCloseMobile?: () => void
  onLoad?: (v: boolean) => void
  typeoformId?: string
} & BoxProps

const RiskScreenerEmbed = ({
  data,
  primaryColor,
  onLoad,
  isFullContainer,
  isDisabledAnimationOnMobile,
  handleOnCloseMobile,
  typeoformId,
  ...boxProps
}: RiskScreenerEmbedProps) => {
  const { asPath, locale, query } = useRouterExtend()
  const { ref, height } = useElementSize()
  const { state } = useAppContext()
  const { selectSubot = [], backgroundColor } = data
  const isMobile = useIsMobile()
  const otherParams = useMemo(() => {
    const queryObj = { ...query }
    delete queryObj.slug
    return queryObj
  }, [query])

  useEffect(() => {
    onLoad?.(height > 0)
  }, [height])

  useEffect(() => {
    if (backgroundColor || primaryColor) {
      console.warn(
        '[Warning] Please remove the setting primaryColor and backgroundColor in the CMS. All these fields will be configured in SubotAdmin.',
      )
    }
  }, [])

  return selectSubot.length > 0 ? (
    <Box ref={ref} {...boxProps}>
      <ErrorBoundary>
        <SubotCss />
        <SubotInlineRevamp
          id={Number(selectSubot[0])}
          isFullContainer={isFullContainer}
          isDisabledAnimationOnMobile={isDisabledAnimationOnMobile}
          onCloseMobile={handleOnCloseMobile}
          articleLink={asPath}
          // bgColor={backgroundColor}
          // primaryColor={primaryColor}
          userInfo={state.userInfo as any}
          typeFormProps={
            typeoformId
              ? {
                  id: typeoformId || '',
                  params: {
                    ga_client: Cookies.get(GA_TOKEN_COOKIE),
                    page_path: asPath,
                    ...otherParams,
                  },
                }
              : undefined
          }
          isMobile={isMobile}
          locale={locale}
        />
      </ErrorBoundary>
    </Box>
  ) : null
}

export { RiskScreenerEmbed }
